export const userKeys = {
  all: () => ['users'],
  list: (params: { page: number; q?: string; sort?: string }) =>
    [...userKeys.all(), 'list', params],
  details: () => [...userKeys.all(), 'detail'],
  detail: (id: number) => [...userKeys.details(), id],
  managers: (userId: number) => [...userKeys.detail(userId), 'managers'],
  roles: (userId: number) => [...userKeys.detail(userId), 'roles'],
  me: () => [...userKeys.all(), 'me'],
};
